import $ from "jquery";


import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/all";

import lazySizes from 'lazysizes';
import 'lazysizes/plugins/object-fit/ls.object-fit';
// import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';


// LazySizes config
//lazySizes.cfg == window. lazySizesConfig
Object.assign(lazySizes.cfg, {
    preloadAfterLoad: true,
});



// Main script
const common = (($) => {
    
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollToPlugin);



    ScrollTrigger.normalizeScroll(true);


    //----------------------
    // VIDEO LAZYLOADING
    //----------------------
    $('[data-lazyload-video]').each(function (index, el) {
        const url = $(this).attr('data-src');
        $(this).attr('src', url);
        // console.log(el, url);
        $(this).on('loadeddata', function (e) {
            // console.log('loadeddata', e.target.duration)
            $(this).addClass('loadeddata')
          })
          $(this).on('load', function (e) {
            // console.log('load', e.target.duration)
            $(this).addClass('load')
          })
    })

    //----------------------
    // VIDEO BLOCK
    //----------------------
    $('[data-video]').each(function (index, el) {
        
        const display = $(this).attr('data-video-display')
        const video = this
        let url
        let type

        if ($('video', this).length) {
        type = 'video'
        url = $('video', this).attr('data-src')
        } else if ($('iframe', this)) {
        type = 'iframe'
        url = $('iframe', this).attr('data-src')
        }

        $('video').on('contextmenu', function (e) {
        e.preventDefault()
        // return false
        })

        $('.video-playButton', this).on('click', function (e) {
        e.preventDefault()
        //   stopAllVideos()
        if (display === 'inline') {
            loadVideo(video)
        } else if (display === 'popup') {
            if (type === 'video') {
            $.magnificPopup.open({
                items: {
                type: 'inline',
                src: '<div class="mfp-inline-video-wrapper"><div class="mfp-inline-video"><button title="Close (Esc)" type="button" class="mfp-close">×</button><video class="mfp-inline-video-video" controls="controls" controlsList="nodownload" src="' + url + '" type="video/mp4" autoplay="autoplay"></video></div></div>'
                }
            })
            } else {
            $.magnificPopup.open({
                items: {
                type: 'iframe',
                src: url
                }
            })
            }
        }
        })
    })

    let videoLoadTimeout

    function loadVideo (video) {
        if ($('video', video).length) {
        $('video', video).attr('src', $('video', video).data('src'))
        }
        if ($('iframe', video).length) {
        $('iframe', video).attr('src', $('iframe', video).data('src'))
        }
        $('.video-player', video).addClass('video-player--isLoading')
        clearTimeout(videoLoadTimeout)
        videoLoadTimeout = setTimeout(() => {
        $('.video-player', video).removeClass('video-player--isLoading')
        $('.video-player', video).addClass('video-player--isLoaded')
        $('.figure-image', video).addClass('figure-image--isHidden')
        }, 1000)
        // $('iframe', video).on('load', videoIsLoaded.bind(video))
    }


    //---------------------------
    // SECTION 1 - Masthead
    //---------------------------

    const mastheadTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: "#section1",
            scrub: 1,
            start: "top top",
            end: "bottom center",
        },
    });

    mastheadTimeline.to(
        ".masthead-content-title, .masthead-content-button",
        {
            y: -50,
            opacity:0,
            filter: "blur(10px)",
        },
    )



    //---------------------------
    // SECTION 2 - VIDEO
    //---------------------------
    
    const videoBlockTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: "#videoBlock",
            scrub: 2,
            start: "top bottom",
            end: "bottom center",
        },
    });

    videoBlockTimeline.fromTo(
        "#videoContainer",
        {   
            y: 50,
        },
        {
            y: -50,
            duration: 6
        }
    )
    
    videoBlockTimeline.fromTo(
        "#gradientOverlay",
        {
            backgroundColor: "rgba(255,256,256,1)"
        },
        {
            backgroundColor: "rgba(255,256,256,0)",
            duration: 4
        },
        "<"
    );


    //--------------------------------------------
    // SECTION 3 - WOULD YOU WEAR PLASTIC SECTION 
    //--------------------------------------------

    let matchMedia = gsap.matchMedia();

    matchMedia.add({
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)",
    }, (context) => {
        let {isMobile} = context.conditions;

        let oilIntroTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: "#oilReveal",
                scrub: isMobile ? 1 : 1.5,
                start: "top bottom",
                end: "bottom bottom",
            },
        });

        oilIntroTimeline.fromTo(
            "#oilRevealTitle, #oilRevealSubtitle",
            {
                y: isMobile ? 170 : 300,
            },
            {
                y: isMobile ? 70 : 140,
                ease: "Power2.easeIn",
            },
        )

        const oilRevealTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: "#oilContainer",
                scrub: 1.5,
                start: "top bottom",
                end: "top 60",
                invalidateOnRefresh: true,
                },
        });

        oilRevealTimeline.fromTo(
            ".whiteBlock-left",
            {
                x: "-20vw",
            },
            {
                x: "-51vw",
                ease: "none"
            },
            "<"
        );
        oilRevealTimeline.fromTo(
            ".whiteBlock-right",
            {
                x: "20vw",
            },
            {
                x: "51vw",
                ease: "none",
            },
            "<"
        );

        gsap.timeline({
            scrollTrigger: {
                trigger: '#oilContainer',
                pin: true,
                anticipatePin: true,
                start: "top top",
                end: () => "+=50%",
                // toggleActions: 'play none none reverse',
                toggleActions: 'play reverse play reverse',
                // markers: true,
            },
            defaults:{ ease:'power1.easeOut'}
          })
          .to('.oil-container-text', {
            opacity: 1,
            duration: 0.5,
          })
          .to('.oil-container-inner .darkOverlay', {
            opacity: 0.15,
            duration: 0.5,
          }, "<");
            

        let previousYears = ["1950","1955"];
        let years = ["1960","1965","1970","1975","1980","1985","1990","1995","1999","2000","2001","2002","2003","2004","2005","2006","2007","2008","2009","2010","2011","2012","2013","2014","2015","2016","2017","2018","2019","2020","2021e","2022f","2023f"];
        let additionalYears = ["2024","2025"];
        let syntheticPercentages = [4.6,11.9,21.6,29.7,35.4,38.1,39.3,45.1,52.0,56.0,56.1,57.0,57.1,58.6,57.8,57.4,57.7,56.9,59.8,60.3,62.3,65.4,65.7,65.7,66.0,66.6,66.6,66.0,67.0,69.8,69.6,70.0,72.8];
        let cottonCellWoolPercentages = [95.4,88.1,78.4,70.3,64.6,61.9,60.7,54.9,48.0,44.0,43.9,43.0,42.9,41.4,42.2,42.6,42.3,43.1,40.2,39.7,37.7,34.6,34.3,34.3,34.0,33.4,33.4,34.0,33.0,30.2,30.4,30.0,27.2];

        let startCount = 0;
        let num = {var:startCount};

        
        let yearsContainer = $("#years");
        previousYears.map(x => yearsContainer.append(`<li>${x}</li>`));
        years.map(x => yearsContainer.append(`<li>${x}</li>`));
        additionalYears.map(x => yearsContainer.append(`<li>${x}</li>`));



        const spacing = 1/6; 
        const snap = gsap.utils.snap(spacing); 
        const cards = gsap.utils.toArray('.years li');
        const seamlessLoop = buildRawSequence(cards, spacing);
        const scrub = gsap.to(seamlessLoop, { 
            totalTime: 0,
            duration: 1,
            ease: "power3",
            paused: true
        });


        const oilDataTL = gsap.timeline({
            scrollTrigger: {
                trigger: "#oilData",
                pin: true,
                anticipatePin: true,
                scrub: isMobile ? 0.3 : 1,
                start: "top 60",
                end: () => "+=150%",
                invalidateOnRefresh: true, 
                onUpdate(self) {
                    scrub.vars.totalTime = snap(self.progress * seamlessLoop.duration());
                    scrub.invalidate().restart(); 
                },
            },
        });



        oilDataTL.fromTo(
            "#blackBackground",
            {
                scaleY: 0,
            },
            {
                scaleY: 1,
                duration: 1
            }, 
        );
        oilDataTL.fromTo(
            "#woolPercentage",
            {
                opacity: 1,
            },
            {
                opacity: 0.2,
                duration: 1
            }, 
            "<"
        );


        oilDataTL.to(num, {var: (syntheticPercentages.length - 1), duration: 1, ease:"none", onUpdate:changeNumber}, "<");

        let riseText = $(".statsBlock-years-riseText");
        function changeNumber() {
            $('#woolPercentage').text( `${(cottonCellWoolPercentages[num.var.toFixed()].toFixed(1))}%`);
            $('#syntheticPercentage').text( `${(syntheticPercentages[num.var.toFixed()].toFixed(1))}%`);

            if (num.var.toFixed() >= 6 ){
                gsap.to(riseText, {opacity: 1, y: 0, duration: "0.1s"});
            }
            else {
                gsap.to(riseText, {opacity: 0, y: -10, duration: "0.1s"});
            }
        };


        ScrollTrigger.create({
            trigger: "#oilContainer",
            start: "center center",
            end: () => "+=200%",
            toggleClass: {
                targets: "#sideNav",
                className: "light"}, 
        });



        function buildRawSequence(items, spacing) {
            let rawSequence = gsap.timeline({paused: true});
            let l = items.length;
            let time = 0;
            let i;
            let item;
            let animDistance = 300;

            gsap.set(items, {xPercent: animDistance, opacity: 0,	scale: 0});

            for (i = 0; i < l; i++) {
                item = items[i];
                time = i * spacing;
                rawSequence
                    .fromTo(item, {
                            scaleX: 0.5, 
                            scaleY: 0.5, 
                            opacity: 0,
                        }, {
                            scaleX: 1, 
                            scaleY: 1, 
                            opacity: 1, 
                            zIndex: 100, 
                            duration: 0.5, 
                            yoyo: true, 
                            repeat: 1, 
                            ease: "power1.in", 
                            immediateRender: false
                        }, time)
                    .fromTo(item, {
                            xPercent: animDistance
                        }, {
                            xPercent: -animDistance, 
                            duration: 1, 
                            ease: "none", 
                            immediateRender: false
                        }, time);
            }
            
            
            let croppedTimeline = gsap.timeline({ paused: true,});
                
            let totalDuration = ( 1 + ((items.length - 1) * spacing));
            let startOffset = previousYears.length + 3;
            let endOffset = additionalYears.length + 3;
            let newDuration = totalDuration - ((startOffset + endOffset) * spacing)
            
            croppedTimeline.fromTo(rawSequence, 
                {
                progress: (startOffset * spacing)/totalDuration,
                },
                {
                progress: 1 - (endOffset * spacing)/totalDuration,
                time: newDuration,
                duration: newDuration,
                ease: "none"
                });
            
            // return rawSequence;
            return croppedTimeline;
        }

    })





    //--------------------------
    // HORIZONTAL REVEAL ANIMATION
    //--------------------------

    gsap.utils.toArray(".reveal-anim").forEach(section => {

        let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: "top 60",
                    toggleActions: "play none none reverse",

                },
                defaults: {ease: "Power3.easeInOut", duration: 1.6}
            });

            tl.fromTo(section.querySelector(".afterImage"), 
                {
                    xPercent: 100, 
                    x: 0,
                }, 
                {
                    xPercent: 50,
                });
                
            tl.fromTo(section.querySelector(".afterImage img"), 
                {
                    xPercent: -100, 
                    x: 0}, 
                {
                    xPercent: -50
                }, "<");
    });





    //---------------------------------------------------
    // SECTION 4 - HOW CAN YOU SLOW DOWN FASHION SECITON
    //---------------------------------------------------




    matchMedia.add("(max-width: 767px)", () => {
        //reset incase desktop anim still applying styles
        gsap.set(".sidePanel-slide", {y: 0, opacity: 1});
        
        const textMobileTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: "#fastFashion",
                start: "top 60",
                end: () => `+=100%`,
                pin: true,
                pinSpacing: true,
                scrub: 1,
                invalidateOnRefresh: true,
            },
        });

        textMobileTimeline.fromTo(
            "#col1, #col2",
            {
                y: 50
            },
            {
                y: -50,
                duration: 2,
                ease: "none",
            },
        );

        gsap.to("#col1, #col2", {
            scrollTrigger: {
                trigger: "#fastFashion",
                start: "top 60",
                end: () => `+=100%`,
                invalidateOnRefresh: true,
                toggleActions: 'play reverse play reverse',
            },
            opacity: 1,
            duration: 0.5,
            ease: 'power1.easeOut'
        });
    });
    matchMedia.add("(min-width: 768px)", () => {
        ScrollTrigger.create({
            trigger: "#fastFashion",
            start: "top 200px",
            end: () => '+=700',
            toggleClass: {targets: ".fastFashion-content-inner", className: "anim-show"}, 
        });
        ScrollTrigger.create({
            trigger: "#fastFashion",
            start: "top -500px",
            end: () => '+=3700',
            toggleClass: {targets: "#fastFashion", className: "panelOpen"}, 
        });
    
        ScrollTrigger.create({
            trigger: "#fastFashion",
            start: "top -500px",
            end: () => '+=5000',
            toggleClass: {targets: "#sideNav",
            className: "dark"}, 
        });
    
        const timelineSlides = gsap.timeline({
            scrollTrigger: {
                trigger: "#fastFashion",
                start: "top 60",
                end: () => `+=2700px`,
                pin: true,
                scrub: 1,
                invalidateOnRefresh: true,
            },
        });
    
    
        timelineSlides.fromTo(
            "#col1, #col2",
            {
                y: 50
            },
            {
                y: -50,
                duration: 2,
                ease: "Power2.easeOut",
            },
        );
    
    
        gsap.utils.toArray(".sidePanel-slide").forEach((section, i, arr) => {
            let distance = "750px";
            let initialPercentage = ((i + 1) / arr.length);
            let percentage = ((i + 2) / arr.length);
    
    
            // first slide
            if (i === 0){
                gsap.set(".progressBar-inner", {scaleX: initialPercentage, x:0});
                timelineSlides.fromTo(
                    section,
                    { 
                        y: 0,
                        opacity: 1,
                    },
                    {
                        y: `-${distance}`,
                        opacity: 0,
                    }, "+=1");
    
                    timelineSlides.to(".progressBar-inner", {
                        scaleX: percentage
                    }, "<");   
    
                
            } else {
                // all other slides 
                timelineSlides.fromTo(
                    section,
                    {
                        y: `${distance}`,
                        opacity: 0,
                    },
                    {
                        y: 0,
                        opacity: 1,
                    }, "<"
                );
    
                // last slide
                if (i === arr.length - 1) {
                    // adding extra time to the last slide
                    timelineSlides.to({}, {duration: 1});
                } else {
                    timelineSlides.to(
                        section, 
                        {
                            y:  `-${distance}`,
                            opacity: 0,
                        }, "+=1");
    
                        timelineSlides.to(".progressBar-inner", {
                            scaleX: percentage
                        }, "<");   
                }
            }
        });
    });      




    //-----------------------------------------
    // SECTION 5 - HORIZONTAL SLIDER SECTION 
    //-----------------------------------------

    matchMedia.add("(max-width: 767px)", () => {
            const hasContent = gsap.utils.toArray(".hasContent");

            hasContent.forEach((sct, i) => {

                gsap.timeline({
                    scrollTrigger: {
                        trigger: sct,
                        start: "top center",
                        end: "bottom center",
                        toggleActions: 'play reverse play reverse',
                    },
                    defaults:{ ease:'power1.easeOut', duration: 0.3}
                  })
                  .to(sct.querySelector(".slide-content").children, {
                    opacity: 1,
                  })
                  .to(sct.querySelectorAll(".slide-number"), {
                    color: "#000000",
                  }, "<");
            });


            //----------------------------
            // Mobile Paralax Image
            //----------------------------

            let paralxTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: "#leafSlide",
                    start: 'top bottom',
                    end: 'bottom 60px',
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            paralxTimeline.fromTo("#mobileLeafBg", {
                y: "-20%",
                // y: "-30%",
            }, {
                y: "25%",
                // y: "10%",
                duration: 2,
                ease: "none",
            }, "<");


            paralxTimeline.fromTo((".scrollVideo-content-text, .scrollVideo-content-reference"), 
            { 
                scale: 1.2,
                opacity: 0,
                filter: "blur(10px)",
                duration: 1.2,
            },
            { 
                scale: 1,
                opacity: 1,
                filter: "blur(0px)",
                duration: 1.2,
            }, "<");

    });
    matchMedia.add("(min-width: 768px)", () => {
        // "(min-width: 768px)": function() {

            const sections = gsap.utils.toArray(".slide-wrapper");
            let maxWidth = 0;

            const getMaxWidth = () => {
                maxWidth = 0;
                sections.forEach((section, i) => {
                    if (i !== sections.length - 1) {
                        maxWidth += section.offsetWidth;
                    }
                });
            };
            
            ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

            getMaxWidth();


            const testTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: "#horizontalSlider",
                    pin: true,
                    scrub: 0.3,
                    start: "center 50%+=30px",
                    end: () => `+=${maxWidth}`,
                    invalidateOnRefresh: true, 
                    toggleClass: {
                        targets: "#sideNav",
                        className: "light"}, 
                },
            });


            testTimeline.fromTo(sections, 
                { 
                    x: 0, 
                    ease: "none",
                },
                {
                    x: () => `-${maxWidth}`, 
                    ease: "none",
                    duration: 7,

                }
            );

            testTimeline.fromTo(("#leafSlide"), 
            { 
                maxHeight: "580px",
            }, 
            {
                maxHeight: "100vh",
                duration: 3,
            });


            //ration of the timeline durations (horizontal sliding : total duration)
            let ratio = 7/10.5;


            const hasContent = gsap.utils.toArray(".hasContent");
            hasContent.forEach((sct, i) => {
                let slideWidth = sct.offsetWidth;
                gsap.timeline({
                    scrollTrigger: {
                        trigger: sct,
                        start: () => 'top top-=' + (sct.offsetLeft - slideWidth - 200 ) * ratio,
                        end: () => '+=' + slideWidth * ratio,
                        toggleActions: 'play reverse play reverse',
                        // markers: true,
                    },
                    defaults:{ ease:'power1.easeOut', duration: 0.3}
                  })
                  .to(sct.querySelector(".slide-content").children, {
                    opacity: 1,
                  })
                  .to(sct.querySelectorAll(".slide-number"), {
                    color: "#000000",
                  }, "<");
            });
  



            //----------------------------
            // scroll to scrub video    
            //----------------------------

            let video = document.getElementById('scrollVideo');
            // video.addEventListener("loadedmetadata", getmetadata);

            // // additional check if metadata loaded ( 1 === HAVE_METADATA)
            // if (video.readyState >= 1) {
            //     getmetadata();
            // }

            // function getmetadata()
            // {
                // console.log("Meta data for video loaded");

                // let duration = video.duration;
                // duration = Math.round(duration * 10) / 10

                let duration = 6.2;

                let videoTimeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: video,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: 0.7,
                        currentTime: duration,
                    }
                });

                testTimeline.to(video, { 
                    currentTime: duration, 
                    duration: 3.5, 
                }, "<");
                testTimeline.fromTo((".scrollVideo-content-text, .scrollVideo-content-reference"), 
                { 
                    scale: 1.2,
                    opacity: 0,
                    filter: "blur(10px)",
                },
                { 
                    scale: 1,
                    opacity: 1,
                    filter: "blur(0px)",
                }, "<40%");
            // }
    });  
    



    //---------------------------
    // SECTION 6 - Shop 
    //---------------------------

    const shopTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: "#section6",
            scrub: 1,
            start: "top bottom",
            end: "top 20%",
        },
    });

    shopTimeline.from(
        ".shop-content-title, .shop-content-button",
        {
            y: -50,
            opacity:0,
            filter: "blur(10px)",
        },
    );

    gsap.utils.toArray('.dark-nav').forEach((section, i) => {          
        ScrollTrigger.create({
          trigger: section,
          start: 'top center',
          end: 'bottom center',
          toggleClass: {
            targets: "#sideNav",
            className: "dark"
          },
        })
    });



    //------------------------
    // SIDE NAV - SCROLL TO
    //------------------------

    document.querySelectorAll(".sideNav-section").forEach((btn, index) => {
        btn.addEventListener("click", () => {
          gsap.to(window, {duration: 2, scrollTo:{y:"#section" + (index + 1), offsetY: 59}});
        // console.log("got to section " + (index + 1));
        });
      });


      // Section 1 watch the film anchor link 
      $("#watchFilmBtn").on("click", () => {
        gsap.to(window, {duration: 2, scrollTo:{y:"#section2"}});
      });



    //-------------------------------
    // SIDE NAV ADDING SELECTED CLASS
    //-------------------------------
    let sideNavSections = document.querySelectorAll(".sideNav-section");
    gsap.utils.toArray('section').forEach((section, i) => {           
        ScrollTrigger.create({
          trigger: section,
          start: 'top 100px',
          end: 'bottom 100px',
          toggleClass: {
            targets: sideNavSections[i],
            className: "selected"
          },
        })
    });



    
    //------------------
    // MAIN NAV TOGGLE 
    //------------------
    
    let navToggle = $( ".eco-siteHeader-navbarToggle" );
    navToggle.on("click", function() {
        if( navToggle.hasClass("is-collapsed")) {
            navToggle.removeClass("is-collapsed");
            $(".eco-siteHeader").addClass("navExpanded");
        } else {
            navToggle.addClass("is-collapsed");
            $(".eco-siteHeader").removeClass("navExpanded");
        }
    });

    //--------------------
    // FOOTER LANG TOGGLE
    //--------------------

    let langToggle = $( ".eco-siteFooter-langSelect" );
    langToggle.on("click", function() {
        // console.log("toggle hit");
        if( langToggle.hasClass("show")) {
            langToggle.removeClass("show");
            $(".eco-siteFooter-langOpt").removeClass("show");
        } else {
            langToggle.addClass("show");
            $(".eco-siteFooter-langOpt").addClass("show");
        }
    });



    /**
     * Fire events on document ready and bind other events
     */
    const ready = () => {
        // console.log('page loaded');
    };

    /**
     * Only expose the ready function to the world
     */
    return {
        ready: ready
    }

})($);

// Run main script
$(common.ready);
